/* fill-locator.js — runs only when #fill-station-locator exists */
(function () {
  const root = document.getElementById('fill-station-locator');
  if (!root) return;

  const API_KEY = window.NLR_API_KEY || window.NREL_API_KEY || '';
  const API_URL = 'https://developer.nlr.gov/api/alt-fuel-stations/v1/nearest.json';

  const meta = document.getElementById('fsl-meta');
  const fuelDefault = root.dataset.fuel || 'CNG';
  const radiusDefault = root.dataset.radius || '25';

  root.innerHTML = `
    <div style="display:grid;gap:12px;">
      <form id="fsl-form" style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;">
        <input id="fsl-address" type="text" placeholder="Enter city, ZIP, or address…" style="flex:1;min-width:220px;padding:10px;border:1px solid #ccc;border-radius:6px;">
        <select id="fsl-fuel" style="padding:10px;border:1px solid #ccc;border-radius:6px;">
          ${[['CNG','CNG'],['LNG','LNG'],['LPG','Propane'],['E85','E85'],['ELEC','Electric'],['HY','Hydrogen'],['BD','Biodiesel'],['RD','Renewable Diesel']]
            .map(([v,l]) => `<option value="${v}" ${v === fuelDefault ? 'selected' : ''}>${l}</option>`).join('')}
        </select>
        <select id="fsl-radius" style="padding:10px;border:1px solid #ccc;border-radius:6px;">
          ${[10,25,50,100,500].map(r => `<option value="${r}" ${String(r) === String(radiusDefault) ? 'selected' : ''}>${r} mi</option>`).join('')}
        </select>
        <button type="submit" style="padding:10px 14px;border:1px solid #333;background:#111;color:#fff;border-radius:6px;cursor:pointer;">Search</button>
        <button type="button" id="fsl-geolocate" style="padding:10px 14px;border:1px solid #777;background:#fff;color:#111;border-radius:6px;cursor:pointer;">Use My Location</button>
      </form>
      <div id="fsl-map" style="height:420px;border-radius:10px;overflow:hidden;"></div>
      <ol id="fsl-list" style="display:grid;gap:10px;padding-left:20px;"></ol>
    </div>
  `;

  function setStatus(msg) {
    if (meta) meta.textContent = msg;
  }

  if (!API_KEY) {
    setStatus('Missing API key.');
    return;
  }

  const map = L.map('fsl-map');
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 20,
    attribution: '&copy; OpenStreetMap'
  }).addTo(map);

  const markers = L.layerGroup().addTo(map);
  map.setView([36.7783, -119.4179], 6);

  const form = document.getElementById('fsl-form');
  const address = document.getElementById('fsl-address');
  const fuel = document.getElementById('fsl-fuel');
  const radius = document.getElementById('fsl-radius');
  const list = document.getElementById('fsl-list');
  const geolocateBtn = document.getElementById('fsl-geolocate');

  async function geocode(q) {
    const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(q)}`;
    const res = await fetch(url, {
      headers: { 'Accept-Language': 'en' }
    });

    if (!res.ok) throw new Error('Location search failed.');

    const data = await res.json();
    if (!data || !data.length) throw new Error('No results for that location.');

    return {
      lat: parseFloat(data[0].lat),
      lng: parseFloat(data[0].lon)
    };
  }

  async function fetchStations({ lat, lng, fuelCode, radiusMiles }) {
    const url = new URL(API_URL);

    url.searchParams.set('api_key', API_KEY);
    url.searchParams.set('latitude', lat);
    url.searchParams.set('longitude', lng);
    url.searchParams.set('fuel_type', fuelCode);
    url.searchParams.set('access', 'public');
    url.searchParams.set('status', 'E');
    url.searchParams.set('radius', radiusMiles);
    url.searchParams.set('limit', '200');

    const res = await fetch(url.toString());

    if (!res.ok) {
      throw new Error(`NLR API request failed: ${res.status}`);
    }

    return res.json();
  }

  function stationAddress(s) {
    return [s.street_address, s.city, s.state, s.zip].filter(Boolean).join(', ');
  }

  function render(stations, center) {
    markers.clearLayers();
    list.innerHTML = '';

    if (!stations.length) {
      setStatus('No stations found. Try a larger radius or a different fuel.');
      map.setView([center.lat, center.lng], 9);
      return;
    }

    const bounds = L.latLngBounds();

    stations.forEach((s) => {
      if (s.latitude == null || s.longitude == null) return;

      const ll = [s.latitude, s.longitude];
      bounds.extend(ll);

      const name = s.station_name || 'Station';
      const addr = stationAddress(s);
      const phone = s.station_phone ? ` • ${s.station_phone}` : '';
      const distance = s.distance ? `${Number(s.distance).toFixed(1)} mi` : '';

      const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addr)}`;

      const popup = `
        <strong>${name}</strong><br>
        ${addr}<br>
        ${distance ? `<em>${distance} away</em><br>` : ''}
        ${s.access_days_time ? `${s.access_days_time}<br>` : ''}
        ${s.cng_psi ? `PSI: ${s.cng_psi}<br>` : ''}
        ${s.cng_fill_type_code ? `Fill Type: ${s.cng_fill_type_code}<br>` : ''}
        ${s.station_phone || ''}
      `;

      L.marker(ll).addTo(markers).bindPopup(popup);

      const li = document.createElement('li');
      li.innerHTML = `
        <strong>${name}</strong><br>
        <span style="color:#555">${addr}</span>
        ${distance ? ` · <em>${distance}</em>` : ''}
        ${phone}<br>
        ${s.access_days_time ? `<span style="color:#555">Hours: ${s.access_days_time}</span><br>` : ''}
        ${s.cng_psi ? `<span style="color:#555">PSI: ${s.cng_psi}</span><br>` : ''}
        <a href="${mapsUrl}" target="_blank" rel="noopener">Open in Google Maps</a>
      `;
      list.appendChild(li);
    });

    if (bounds.isValid()) {
      map.fitBounds(bounds.pad(0.2));
    } else {
      map.setView([center.lat, center.lng], 11);
    }

    setStatus(`${stations.length} station(s) shown`);
  }

  async function runQuery(q) {
    try {
      setStatus('Searching…');
      const center = await geocode(q);
      const data = await fetchStations({
        lat: center.lat,
        lng: center.lng,
        fuelCode: fuel.value,
        radiusMiles: radius.value
      });
      render(data.fuel_stations || [], center);
    } catch (error) {
      console.error(error);
      setStatus(error.message || 'Search failed.');
    }
  }

  async function runCoords(lat, lng) {
    try {
      setStatus('Searching…');
      const center = { lat, lng };
      const data = await fetchStations({
        lat,
        lng,
        fuelCode: fuel.value,
        radiusMiles: radius.value
      });
      render(data.fuel_stations || [], center);
    } catch (error) {
      console.error(error);
      setStatus(error.message || 'Search failed.');
    }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const q = address.value.trim();

    if (q) {
      runQuery(q);
    } else {
      geolocateBtn.click();
    }
  });

  geolocateBtn.addEventListener('click', function () {
    setStatus('Locating…');

    if (!navigator.geolocation) {
      setStatus('Geolocation not supported. Enter a city or ZIP.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        runCoords(pos.coords.latitude, pos.coords.longitude);
      },
      function () {
        setStatus('Location blocked. Enter a city or ZIP instead.');
      },
      {
        enableHighAccuracy: true,
        timeout: 10000
      }
    );
  });

  runCoords(36.7378, -119.7871);
})();